import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import {
    Builder_,
    Dropdown_
} from "monica-alexandria";
import { Calendar_Field } from "../../../../components/form/Calendar_Field";
import { Sales_Lead_Quill_Field } from "./Sales_Lead_Quill_Field";
import {
    prospectLeadProgressActionCreateOffer,
    prospectLeadProgressActionNotInterested,
    prospectLeadProgressActionReschedule,
    prospectLeadProgressActionSass,
    prospectLeadProgressActions
} from "../utils/sales_helpers";
import { read_seller_options } from "../../../../utils/hr/seller_identity";

const SalesProgressAction = styled.div`
    display: grid;
    gap: 1rem;
    width: 100%;
    min-width: 0;
    overflow: visible;
`;

const ProspectLeadProgressError = styled.div`
    color: var(--error);
`;

/**
 * Renders the save outcome controls available from an In Progress lead.
 */
export const Sales_Lead_Progress_Action = (props) => {
    const { t } = useTranslation();
    const showCalendar = [
        prospectLeadProgressActionReschedule,
        prospectLeadProgressActionSass
    ].includes(props?.action);
    const calendarLabel = {
        [prospectLeadProgressActionReschedule]: t("Reschedule date"),
        [prospectLeadProgressActionSass]: t("Meeting date")
    }[props?.action] || t("Date");
    const showComment = props?.action === prospectLeadProgressActionNotInterested;
    const showCaller = props?.action === prospectLeadProgressActionSass;
    const sellerOptions = read_seller_options(props?.teamMembers);

    return (
        <SalesProgressAction>
            <Builder_>
                <Dropdown_ label={t("STATUS")}>
                    <select
                        value={props?.action}
                        onChange={(event) => props?.onAction(event.target.value)}
                    >
                        {prospectLeadProgressActions.map((action) => (
                            <option
                                key={action.value}
                                value={action.value}
                                disabled={
                                    props?.contractSentDisabled && action.value === prospectLeadProgressActionCreateOffer
                                }
                            >
                                {t(action.label)}
                            </option>
                        ))}
                    </select>
                </Dropdown_>
            </Builder_>

            {showCalendar ? (
                <Builder_>
                    <Calendar_Field
                        label={calendarLabel}
                        required
                        selected={props?.date ? new Date(props?.date) : null}
                        defaultDate={props?.date ? new Date(props?.date) : null}
                        onChange={(date) => props?.onDate(date)}
                        placeholder={t("Choose date and time")}
                        interval={15}
                        minDate={new Date()}
                        minHour={8}
                        maxHour={22}
                    />
                </Builder_>
            ) : null}

            {showCaller ? (
                <Builder_>
                    <Dropdown_ label={t("Caller")}>
                        <select
                            required
                            value={props?.caller || ""}
                            onChange={(event) => props?.onCaller(event.target.value)}
                        >
                            <option value="">{t("Select caller")}</option>
                            {sellerOptions.map((member) => (
                                <option
                                    key={member.key}
                                    value={member.value}
                                >
                                    {member.label}
                                </option>
                            ))}
                        </select>
                    </Dropdown_>
                </Builder_>
            ) : null}

            {showComment ? (
                <Sales_Lead_Quill_Field
                    placeholder={t("Comment")}
                    value={props?.comment}
                    error={props?.error}
                    onChange={(html) => props?.onComment(html)}
                />
            ) : null}

            {props?.error && !showComment ? (
                <ProspectLeadProgressError>
                    <h6>{props?.error}</h6>
                </ProspectLeadProgressError>
            ) : null}
        </SalesProgressAction>
    );
};
